const ModalBox = {
  backgroundColor: "white",
  width: "500px",
  height: "500px",
  padding: "48px",
  boxSizing: "border-box"

}

export default ModalBox;